import { useSelector } from 'react-redux';
import { ReduxState } from '../store';
import { RoutingSubpage } from '../routes/routerSlice';

const useSubpage = (): RoutingSubpage | undefined => {
  return useSelector((state: ReduxState) => state.routerReducer.subpage);
};

export default useSubpage;
